import * as Types from "../types";

const isActive = (
  { customActiveCondition = "", href = "" }: Types.Item | Types.SubItem,
  currentPath: string,
): boolean => {
  if (customActiveCondition) {
    return Boolean(currentPath.match(`^${customActiveCondition}`));
  }

  if (href) {
    return href === currentPath;
  }

  return false;
};

export default isActive;
